import NoteAltIcon from '@mui/icons-material/NoteAlt';
import { Box, useTheme } from '@mui/material';
import React from 'react';

const NoteIcon = ({ boxSize, iconSize }) => {
  const theme = useTheme();
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: boxSize,
        height: boxSize,
        borderRadius: '50%',
        backgroundColor: theme.palette.icon.notes.background,
      }}
    >
      <NoteAltIcon
        sx={{
          color: theme.palette.icon.notes.contrast,
          fontSize: iconSize,
        }}
      />
    </Box>
  );
};

export default NoteIcon;
